import React, { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { BeatLoader } from 'react-spinners';

import { useManagementContactsList } from '@hooks/API/Contact/UseContactsList';

import GlobalSearch from '@components/_LayoutComponents/Header/GlobalSearch/GlobalSearch';

import StyleVariables from '@components/Gui/StyleVariables';

const GlobalSearchWrapperManagement = () => {
    const { data: managementContacts, isFetching: loadingManagementContacts } = useManagementContactsList();
    const navigate = useNavigate();

    const getItemSearchGroup = (subtype) => {
        return subtype === 4
            ? 'models'
            : subtype === 5
              ? 'scouting'
              : subtype === 1
                ? 'clients'
                : subtype === 2
                  ? 'agencies'
                  : 'services';
    };

    const sources = useMemo(() => {
        if (loadingManagementContacts) {
            return [];
        }

        const source = managementContacts
            ? managementContacts.map((item) => ({
                  ID: item.ID,
                  cover: null,
                  subtype: item.ST,
                  showValue: `${item.N.trim()} ${item.S ? item.S.trim() : ''}`,
                  searchValue: item._normalizedFullName,
                  secondLine: null,
                  searchGroup: getItemSearchGroup(item.ST),
              }))
            : [];

        return source;
    }, [managementContacts, loadingManagementContacts]);

    const onSearchContact = (contactInfo) => {
        if (contactInfo.type === 'model') {
            navigate(`/accounting/model/${contactInfo.ID}`);
        } else {
            navigate(`/accounting/customer/${contactInfo.ID}`);
        }
    };

    if (loadingManagementContacts) {
        return <BeatLoader size={8} color={StyleVariables.PrimaryColor} />;
    }
    return <GlobalSearch sources={sources} onSearchContact={onSearchContact} />;
};

export default GlobalSearchWrapperManagement;
